import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumnWideHalf"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconColumnWideHalf;
